import { render, staticRenderFns } from "./tr-pair.vue?vue&type=template&id=7c17e4f0&scoped=true&"
import script from "./tr-pair.vue?vue&type=script&lang=js&"
export * from "./tr-pair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c17e4f0",
  null
  
)

export default component.exports